import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { CxInteractionFormComponent } from 'app/cx-interaction/cx-interaction-form.component';
import { environment } from 'environments/environment';
import { GetInteractionTagLists, SaveCxInteraction } from 'app/store/cx-interaction/cx-interaction.action';
import { CXInteractionState } from 'app/store/cx-interaction/cx-interaction.state';
import { TagLists } from 'app/models/cx-interaction/cx-interaction-tag-list.interface';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
  selector: 'app-cx-interaction-smart',
  templateUrl: './cx-interaction-smart.component.html',
  styleUrls: ['./cx-interaction-smart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CxInteractionSmartComponent implements OnInit, OnDestroy {

  @ViewChild(CxInteractionFormComponent) cxInteractionFormComponent: CxInteractionFormComponent;
  @Output() cxDrawerClose = new EventEmitter<boolean>();
  @Select(CXInteractionState.tagLists) tags$: Observable<TagLists[]>;
  destroyed$ = new Subject<boolean>();
  tagOptions: TagLists[];
  loaded = false;
  formSaving = false;
  @Input() user: LenderUser;



  constructor(
    private store: Store,
  ) { }

  ngOnInit(){
    this.store.dispatch(new GetInteractionTagLists());
    this.tags$.pipe(takeUntil(this.destroyed$)).subscribe(
      (options) => {
        if (options === undefined || options.length === 0) {
          return;
        }
        this.tagOptions = options;
      }
    );
  }

  sideNavClose() {
    this.cxDrawerClose.emit(true);
  }

  onSaveCxInteraction(cxInteractionInfo: object) {
    cxInteractionInfo['info']['lenderUserId'] = this.user.id;
    this.formSaving = true;

    this.store.dispatch(new SaveCxInteraction(
      cxInteractionInfo['info'],
      cxInteractionInfo['form'],
      cxInteractionInfo['directive'],
      cxInteractionInfo['cxComponent']
    ));
    this.formSaving = false;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }
}
